import { Phone, ShieldCheck, Sparkles } from "lucide-react";
import { PHONE_DISPLAY, PHONE_LINK } from "@/lib/data";
import { scrollToId } from "@/App";

export const Footer = () => (
  <footer className="border-t border-amber-500/15 bg-[#04100A]" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-amber-400 to-amber-600 gold-glow">
              <Sparkles size={18} className="text-stone-950" />
            </span>
            <span className="font-display text-lg font-bold text-amber-50">Southern Christmas Co.</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-emerald-100/60">
            Architectural holiday illumination for Southern homes. Installation, season-long maintenance and January takedown — all handled.
          </p>
        </div>
        <div>
          <p className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-amber-400">Service Area</p>
          <ul className="mt-4 space-y-2 text-sm text-emerald-100/70">
            <li>Greater Metro Atlanta</li>
            <li>North Georgia suburbs</li>
            <li>Marietta · Roswell · Alpharetta · Woodstock</li>
          </ul>
        </div>
        <div>
          <p className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-amber-400">Talk to a Real Person</p>
          <a href={PHONE_LINK} data-testid="footer-phone-link" className="font-display mt-4 flex items-center gap-3 text-3xl font-black text-amber-50 transition-colors hover:text-amber-400">
            <Phone size={24} className="text-amber-400" />
            {PHONE_DISPLAY}
          </a>
          <button
            onClick={() => scrollToId("booking")}
            data-testid="footer-book-button"
            className="mt-5 rounded-full border border-amber-500/40 px-6 py-3 text-xs font-bold uppercase tracking-widest text-amber-300 transition-all hover:bg-amber-500/10"
          >
            Get a Quick Quote
          </button>
        </div>
      </div>
      <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-amber-500/10 pt-7">
        <p className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-emerald-100/40">
          © 2026 Southern Christmas Co. · All rights reserved
        </p>
        <p className="flex items-center gap-2 font-mono-x text-[10px] uppercase tracking-[0.2em] text-emerald-100/40">
          <ShieldCheck size={13} className="text-amber-400" /> Licensed & Insured · 48-Hour Service Guarantee
        </p>
      </div>
    </div>
  </footer>
);
